/**
 * A deal stage's status, whichever key it was written under: deal creation writes lowercase
 * `status`, while completing a stage writes capital `Status` (see `setStageStatus`).
 */
export const getStageStatus = (stage: Record<string, unknown> | null | undefined): string | null => {
  if (!stage) {
    return null;
  }

  const statusValue = stage.Status ?? stage.status;
  return typeof statusValue === "string" ? statusValue : null;
};
